import { Box, HStack, IconButton, Shadow, Text, VStack } from '@genial/components';
import { BoxBorder } from '@genial/design-tokens';
import React from 'react';

import { ItemResponsiveProps } from '.';

export const TabletItem: React.FC<ItemResponsiveProps> = ({
  asset,
  descriptionType,
  description,
  requestedDate,
  settlementDate,
  formattedValue,
  quantity,
  valueIsPositive,
  statusIcon,
  statusDescription,
  cancelButtonIsDisabled,
  productType,
  handleCancelMovement,
}) => {
  const isTreasury = productType === 'Treasury';

  return (
    <Shadow borderRadius={BoxBorder.heavy} p="inline.xxxs" level={3} my="stack.nano">
      <VStack space="inline.xxxs" borderRadius={BoxBorder.heavy} w="full">
        <HStack alignItems="center" justifyContent="space-between">
          <Text variant="semibold" color="neutral.black" fontSize="md">
            {descriptionType}
          </Text>
          <Text variant="semibold" color="neutral.black" fontSize="md">
            {description}
          </Text>
        </HStack>
        <Box h={0.5} bg="neutral.lightest" />
        <HStack alignItems="center" justifyContent="space-between" space="stack.quarck">
          <VStack space="inline.quarck" w="1/6">
            <Text variant="semibold" color="neutral.black" fontSize="md">
              Data de solicitação
            </Text>
            <Text color="neutral.dark" fontSize="md">
              {requestedDate}
            </Text>
          </VStack>
          <VStack space="inline.quarck" w="1/6">
            <Text variant="semibold" color="neutral.black" fontSize="md">
              Data de liquidação
            </Text>
            <Text color="neutral.dark" fontSize="md">
              {settlementDate}
            </Text>
          </VStack>
          <VStack space="inline.quarck" w="1/6">
            <Text variant="semibold" color="neutral.black" fontSize="md">
              Valor
            </Text>
            {isTreasury ? (
              <VStack space="stack.quarck">
                <Text fontSize="xs" color="neutral.black" variant="bold">
                  {formattedValue}
                </Text>
                <Text fontSize="xs" color="neutral.black">
                  Quantidade {quantity}
                </Text>
              </VStack>
            ) : (
              <Text
                color={valueIsPositive ? 'feedback.success.default' : 'feedback.error.default'}
                fontSize="md">
                {formattedValue}
              </Text>
            )}
          </VStack>
          <VStack space="inline.quarck" w="1/6">
            <Text variant="semibold" color="neutral.black" fontSize="md">
              Ativo
            </Text>
            <Text color="neutral.dark" fontSize="md">
              {asset}
            </Text>
          </VStack>
          <VStack space="inline.quarck" w="1/6">
            <Text variant="semibold" color="neutral.black" fontSize="md">
              Status
            </Text>
            <HStack alignItems="center" space="stack.quarck">
              {statusIcon}
              <Text fontSize="xs" color="neutral.black">
                {statusDescription}
              </Text>
            </HStack>
          </VStack>
          <IconButton
            onPress={handleCancelMovement}
            icon="Trash"
            testId="cancel-button-icon"
            iconColor={cancelButtonIsDisabled ? 'neutral.light' : 'feedback.error.default'}
            iconSize="xs"
            isDisabled={cancelButtonIsDisabled}
            variant={'unstyled'}
          />
        </HStack>
      </VStack>
    </Shadow>
  );
};
